import React, { useState } from 'react';
import MarbleCard from '../components/MarbleCard';
import italianMarble from '../assets/italian-marble.jpeg';
import granite from '../assets/granite.jpeg';
import onyx from '../assets/onyx.jpeg';
import indianMarble from '../assets/indian-marble.jpg';

const marbleProducts = [
    {
        id: 1,
        name: 'Italian Marble',
        type: 'Premium White',
        image: italianMarble,
        description: 'Exquisite Italian marble with elegant white finish',
        price: '$500/sqft'
    },
    {
        id: 2,
        name: 'Black Granite',
        type: 'Granite',
        image: granite,
        description: 'Sophisticated black granite for modern spaces',
        price: '$350/sqft'
    },
    {
        id: 3,
        name: 'Onyx Stone',
        type: 'Premium',
        image: onyx,
        description: 'Luxurious onyx with translucent properties',
        price: '$600/sqft'
    },
    {
        id: 4,
        name: 'Indian Marble',
        type: 'Traditional',
        image: indianMarble,
        description: 'Classic Indian marble for timeless designs',
        price: '$250/sqft'
    }
];

export default function Collections({ onProductSelect }) {
    const [selectedCategory, setSelectedCategory] = useState('all');

    const handleCardClick = (productId) => {
        const product = marbleProducts.find(p => p.id === productId);
        onProductSelect(product);
    };

    return (
        <div className="collections-page" id="collections">
            <div className="collections-header">
                <h1>Our Collections</h1>
                <p>Explore our premium selection of marbles and stones</p>
            </div>

            <div className="filter-section">
                <button
                    className={selectedCategory === 'all' ? 'filter-btn active' : 'filter-btn'}
                    onClick={() => setSelectedCategory('all')}
                >
                    All
                </button>
                <button
                    className={selectedCategory === 'marble' ? 'filter-btn active' : 'filter-btn'}
                    onClick={() => setSelectedCategory('marble')}
                >
                    Marble
                </button>
                <button
                    className={selectedCategory === 'granite' ? 'filter-btn active' : 'filter-btn'}
                    onClick={() => setSelectedCategory('granite')}
                >
                    Granite
                </button>
                <button
                    className={selectedCategory === 'onyx' ? 'filter-btn active' : 'filter-btn'}
                    onClick={() => setSelectedCategory('onyx')}
                >
                    Onyx
                </button>
            </div>

            <div className="products-grid">
                {marbleProducts.map(product => (
                    <MarbleCard
                        key={product.id}
                        {...product}
                    />
                ))}
            </div>
        </div>
    );
}
